import { Tir } from "../tir";
import { TirsPolygoneType } from "./tirsPolygoneType";

export class TirsPolygone {
  tirsPolygoneId: number;
  listePointsPolygone: string;
  niveauZ: number;
  tirsPolygoneTypeId: number;
  tirId: number;
  tirsPolygoneType: TirsPolygoneType;
  tir: Tir;
}

export enum PolygonType {
  AutomaticFromHoles = 0,
  DrillingContour = 1,
  MuckPile = 2,
  DangerZone = 3
}

export class BlastPolygonWKTDto {
  blastPolygonId: number;
  blastId: number;
  type: PolygonType;
  epsg: number;
  wktPolygon: string;
}